import React from "react";
import PropTypes from "prop-types";
import { DatePickerField } from "../../../components/FormField";
import SoftBox from "../../../components/SoftBox";
import SoftButton from "../../../components/SoftButton";

import { filterPanelStyles } from "../../../examples/Tables/styles";

/** Settlement dates and existing actions share the table filter tray. */
const SettlementsFilters = ({ onClearFilters }) => {
  const dateTimePickerOptions = {
    allowInput: false,
    enableTime: true,
    maxDate: new Date(),
    time_24hr: true,
  };

  return (
    <SoftBox
      sx={(theme) => ({
        ...filterPanelStyles(theme),
        gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr)) auto" },
        alignItems: "end",
        borderRadius: "22px 22px 0 0",
      })}
    >
      <DatePickerField
        name="fromDate"
        options={dateTimePickerOptions}
        label="From Date"
        placeholder="Select start date"
      />
      <DatePickerField
        name="toDate"
        options={dateTimePickerOptions}
        label="To Date"
        placeholder="Select end date"
      />
      <SoftBox display="flex" justifyContent="flex-end" gap={1.25} pb={1}>
        <SoftButton variant="gradient" color="info" type="submit" size="small">
          Search
        </SoftButton>
        <SoftButton
          variant="outlined"
          color="info"
          type="button"
          size="small"
          onClick={onClearFilters}
        >
          Clear filters
        </SoftButton>
      </SoftBox>
    </SoftBox>
  );
};

SettlementsFilters.propTypes = {
  onClearFilters: PropTypes.func,
};

export default SettlementsFilters;
